/**
 * MM Collection Page — smart search, quick tabs, add to cart
 */
(function (global) {
  'use strict';

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    if (global.Shopify && typeof global.Shopify.formatMoney === 'function') {
      return global.Shopify.formatMoney(cents, global.Shopify.money_format || '${{amount}}');
    }
    return (cents / 100).toFixed(2);
  }

  function readCatalog() {
    var el = document.getElementById('mm-collection-catalog');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function priceToCents(val) {
    var n = parseFloat(val);
    if (isNaN(n)) return 0;
    return Math.round(n * 100);
  }

  function mapProductFromJson(p, root) {
    var rawVariants = p.variants || [];
    var variants = rawVariants.map(function (v) {
      return {
        id: v.id,
        title: v.title,
        available: v.available !== false
      };
    });
    var firstRaw =
      rawVariants.find(function (v) {
        return v.available !== false;
      }) || rawVariants[0];
    var price = firstRaw ? priceToCents(firstRaw.price) : 0;
    var compare = firstRaw && firstRaw.compare_at_price
      ? priceToCents(firstRaw.compare_at_price)
      : 0;
    var discount = 0;
    if (compare > price) {
      discount = Math.round(((compare - price) * 100) / compare);
    }
    var multiVariant = variants.length > 1;
    var tags = Array.isArray(p.tags) ? p.tags.join(' ') : p.tags || '';
    return {
      handle: p.handle,
      title: p.title,
      vendor: p.vendor || '',
      url: productUrl(p.handle, root),
      image: p.images && p.images[0] ? p.images[0].src : null,
      priceHtml: formatMoney(price),
      compareHtml: compare > price ? formatMoney(compare) : '',
      discount: discount,
      available: p.available !== false,
      variantId: firstRaw ? firstRaw.id : null,
      multiVariant: multiVariant,
      variants: variants,
      searchIndex: [p.title, p.vendor, p.handle, tags, p.product_type].join(' ')
    };
  }

  function fetchFullCatalog(handle, limit, root, done) {
    if (!handle) {
      done(readCatalog());
      return;
    }
    var base = (root && root.getAttribute('data-shop-root')) || '/';
    if (base.slice(-1) !== '/') base += '/';
    var url =
      base +
      'collections/' +
      encodeURIComponent(handle) +
      '/products.json?limit=' +
      (limit || 250);
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('products.json failed');
        return r.json();
      })
      .then(function (data) {
        var list = (data.products || []).map(function (p) {
          return mapProductFromJson(p, root);
        });
        done(list.length ? list : readCatalog());
      })
      .catch(function () {
        done(readCatalog());
      });
  }

  function matchesQuery(query, haystack) {
    if (!global.MMSmartSearch) {
      return (haystack || '').toLowerCase().indexOf((query || '').toLowerCase()) !== -1;
    }
    return global.MMSmartSearch.matchesFuzzySearch(query, haystack);
  }

  function addToCart(variantId, btn, card) {
    var select = card ? card.querySelector('.mm-col-vselect') : null;
    var vid = select && select.value ? parseInt(select.value, 10) : parseInt(variantId, 10);
    if (!vid || isNaN(vid)) {
      var msg = btn.getAttribute('data-flavour-error') || 'Please select a flavour first';
      alert(msg);
      return;
    }
    var originalHTML = btn.innerHTML;
    var img = card ? card.querySelector('.mm-product-image img') : null;
    var imageUrl = img ? img.src : '';
    var addedLabel = btn.getAttribute('data-added-label') || '✓';

    function onSuccess() {
      btn.classList.remove('mm-atc-busy');
      btn.innerHTML = addedLabel;
      btn.classList.add('is-added');
      setTimeout(function () {
        btn.disabled = false;
        btn.innerHTML = originalHTML;
        btn.classList.remove('is-added');
      }, 1400);
    }

    function onFail() {
      btn.classList.remove('mm-atc-busy');
      alert(btn.getAttribute('data-error-label') || 'Could not add to cart');
      btn.disabled = false;
      btn.innerHTML = originalHTML;
    }

    btn.disabled = true;
    btn.classList.add('mm-atc-busy');

    if (global.MMCart && typeof global.MMCart.add === 'function') {
      global.MMCart.add(vid, 1, { sourceElement: btn, imageUrl: imageUrl, openSheet: true })
        .then(onSuccess)
        .catch(onFail);
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/add.js', true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status === 200 || xhr.status === 201) {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        onSuccess();
      } else {
        onFail();
      }
    };
    xhr.send('id=' + vid + '&quantity=1');
  }

  function buildCard(p, labels) {
    var badge = '';
    if (p.discount > 0) {
      badge =
        '<span class="mm-product-badge mm-product-badge--sale">-' +
        p.discount +
        '%</span>';
    } else if (!p.available) {
      badge =
        '<span class="mm-product-badge mm-product-badge--sold-out">' +
        escapeHtml(labels.soldOut) +
        '</span>';
    }

    var compare =
      p.compareHtml && p.compareHtml.length
        ? '<span class="mm-product-price-compare">' + p.compareHtml + '</span>'
        : '';

    var variants = '';
    if (p.multiVariant && p.variants && p.variants.length) {
      variants = '<select class="mm-col-vselect" aria-label="' + escapeHtml(labels.chooseFlavour) + '">';
      variants += '<option value="">' + escapeHtml(labels.chooseFlavour) + '</option>';
      p.variants.forEach(function (v) {
        variants +=
          '<option value="' +
          v.id +
          '"' +
          (v.available ? '' : ' disabled') +
          '>' +
          escapeHtml(v.title) +
          (v.available ? '' : ' — ' + escapeHtml(labels.soldOut)) +
          '</option>';
      });
      variants += '</select>';
    }

    var img = p.image
      ? '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" loading="lazy" width="400" height="400">'
      : '';

    return (
      '<article class="mm-product-card" data-handle="' +
      escapeHtml(p.handle) +
      '" data-search-index="' +
      escapeHtml(p.searchIndex) +
      '">' +
      '<a href="' +
      escapeHtml(p.url) +
      '" class="mm-product-card__media">' +
      '<div class="mm-product-image"><div class="mm-cimg-corner">' +
      badge +
      '</div>' +
      img +
      '</div></a>' +
      '<div class="mm-product-info">' +
      (p.vendor
        ? '<div class="mm-product-vendor">' + escapeHtml(p.vendor) + '</div>'
        : '') +
      '<h3 class="mm-product-title"><a href="' +
      escapeHtml(p.url) +
      '">' +
      escapeHtml(p.title) +
      '</a></h3>' +
      '<div class="mm-product-price">' +
      '<span class="mm-product-price-current">' +
      (p.priceHtml || '') +
      '</span>' +
      compare +
      '</div>' +
      variants +
      '<button type="button" class="mm-col-add-btn"' +
      (p.available ? '' : ' disabled') +
      ' data-variant-id="' +
      (p.variantId || '') +
      '" data-wait-label="' +
      escapeHtml(labels.wait) +
      '" data-added-label="' +
      escapeHtml(labels.added) +
      '" data-flavour-error="' +
      escapeHtml(labels.chooseFlavourError) +
      '" data-error-label="' +
      escapeHtml(labels.error) +
      '">' +
      escapeHtml(p.available ? labels.addToCart : labels.soldOut) +
      '</button>' +
      '</div></article>'
    );
  }

  function productUrl(handle, root) {
    var base = (root && root.getAttribute('data-shop-root')) || '/';
    if (base.slice(-1) !== '/') base += '/';
    return base + 'products/' + handle;
  }

  function initInfiniteScroll(root, grid, state, getOriginalHtml, setOriginalHtml) {
    var sentinel = document.getElementById('mmColInfiniteSentinel');
    var loader = document.getElementById('mmColInfiniteLoader');
    var endEl = document.getElementById('mmColInfiniteEnd');
    if (!sentinel || !grid || root.getAttribute('data-infinite-scroll') !== 'true') return;

    var inf = {
      sectionId: root.getAttribute('data-section-id'),
      baseUrl: root.getAttribute('data-collection-url') || window.location.pathname,
      page: parseInt(sentinel.getAttribute('data-current-page'), 10) || 1,
      totalPages: parseInt(sentinel.getAttribute('data-total-pages'), 10) || 1,
      loading: false,
      observer: null
    };
    state.infinite = inf;
    state.searchActive = false;

    if (inf.page >= inf.totalPages) {
      sentinel.hidden = true;
      if (endEl && inf.totalPages > 1) endEl.hidden = false;
      return;
    }

    function buildSectionUrl(page) {
      var path = inf.baseUrl.split('?')[0];
      var params = new URLSearchParams(window.location.search);
      params.delete('sections');
      params.set('page', String(page));
      params.set('sections', inf.sectionId);
      var qs = params.toString();
      return qs ? path + '?' + qs : path + '?page=' + page + '&sections=' + inf.sectionId;
    }

    function loadMoreViaView(nextPage) {
      var path = inf.baseUrl.split('?')[0];
      var params = new URLSearchParams(window.location.search);
      params.delete('sections');
      params.set('page', String(nextPage));
      params.set('view', 'mm-col-grid');
      var url = path + '?' + params.toString();
      return fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var wrap = doc.querySelector('.mm-col-grid-ajax');
          if (!wrap) throw new Error('no partial');
          var cards = wrap.querySelectorAll('.mm-product-card');
          cards.forEach(function (card) {
            grid.appendChild(document.importNode(card, true));
          });
          inf.page = nextPage;
          if (wrap.getAttribute('data-has-more') !== 'true') {
            inf.totalPages = inf.page;
          }
          setOriginalHtml(grid.innerHTML);
          if (inf.page >= inf.totalPages) {
            if (inf.observer) inf.observer.disconnect();
            sentinel.hidden = true;
            if (endEl) endEl.hidden = false;
          }
        })
        .catch(function () { /* ignore */ });
    }

    function loadMore() {
      if (inf.loading || inf.page >= inf.totalPages || state.searchActive) return;
      inf.loading = true;
      if (loader) loader.hidden = false;

      var nextPage = inf.page + 1;
      fetch(buildSectionUrl(nextPage), { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('fetch failed');
          return r.json();
        })
        .then(function (data) {
          var html = data[inf.sectionId];
          if (!html) throw new Error('empty section');
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var cards = doc.querySelectorAll('#mmColGrid .mm-product-card');
          cards.forEach(function (card) {
            grid.appendChild(document.importNode(card, true));
          });
          inf.page = nextPage;
          var newSentinel = doc.getElementById('mmColInfiniteSentinel');
          if (newSentinel) {
            var tp = parseInt(newSentinel.getAttribute('data-total-pages'), 10);
            if (tp) inf.totalPages = tp;
          }
          setOriginalHtml(grid.innerHTML);
          if (inf.page >= inf.totalPages) {
            if (inf.observer) inf.observer.disconnect();
            sentinel.hidden = true;
            if (endEl) endEl.hidden = false;
          }
        })
        .catch(function () {
          return loadMoreViaView(nextPage);
        })
        .finally(function () {
          inf.loading = false;
          if (loader) loader.hidden = true;
        });
    }

    inf.observer = new IntersectionObserver(
      function (entries) {
        if (entries[0] && entries[0].isIntersecting) loadMore();
      },
      { rootMargin: '480px 0px' }
    );
    inf.observer.observe(sentinel);

    state.infiniteShow = function () {
      sentinel.hidden = false;
      if (endEl) endEl.hidden = inf.page >= inf.totalPages;
      if (inf.page < inf.totalPages && inf.observer) inf.observer.observe(sentinel);
    };
    state.infiniteHide = function () {
      if (inf.observer) inf.observer.disconnect();
      sentinel.hidden = true;
      if (loader) loader.hidden = true;
      if (endEl) endEl.hidden = true;
    };
  }

  function positionTabIndicator(tabsWrap, activeTab, indicator) {
    if (!tabsWrap || !activeTab || !indicator) return;
    var offset = activeTab.offsetLeft - tabsWrap.scrollLeft;
    indicator.style.width = activeTab.offsetWidth + 'px';
    indicator.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
  }

  function parseSectionGrid(html, sectionId) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var sectionHtml = html;
    if (typeof html === 'object' && html !== null && sectionId && html[sectionId]) {
      sectionHtml = html[sectionId];
      doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
    }
    var newGrid = doc.getElementById('mmColGrid');
    var sentinel = doc.getElementById('mmColInfiniteSentinel');
    return {
      gridHtml: newGrid ? newGrid.innerHTML : '',
      page: sentinel ? parseInt(sentinel.getAttribute('data-current-page'), 10) || 1 : 1,
      totalPages: sentinel ? parseInt(sentinel.getAttribute('data-total-pages'), 10) || 1 : 1,
      hasMore: sentinel ? sentinel.getAttribute('data-has-more') !== 'false' : false
    };
  }

  function initQuickNav(root, grid, state, setOriginalHtml) {
    var tabsWrap = document.getElementById('mmColQuickTabs');
    var indicator = document.getElementById('mmColTabIndicator');
    var quickLoader = document.getElementById('mmColQuickLoader');
    var sortSelect = document.getElementById('mm-sort');
    var sectionId = root.getAttribute('data-section-id');
    var loading = false;

    function setLoading(on) {
      loading = on;
      if (tabsWrap) tabsWrap.classList.toggle('is-loading', on);
      if (quickLoader) quickLoader.classList.toggle('is-visible', on);
    }

    function syncInfiniteFromParsed(parsed) {
      if (!state.infinite) return;
      state.infinite.page = parsed.page;
      state.infinite.totalPages = parsed.totalPages;
      var sentinel = document.getElementById('mmColInfiniteSentinel');
      if (sentinel) {
        sentinel.setAttribute('data-current-page', String(parsed.page));
        sentinel.setAttribute('data-total-pages', String(parsed.totalPages));
        sentinel.hidden = parsed.page >= parsed.totalPages;
      }
      var endEl = document.getElementById('mmColInfiniteEnd');
      if (endEl) endEl.hidden = parsed.page < parsed.totalPages;
      if (parsed.page < parsed.totalPages && state.infinite.observer && sentinel) {
        state.infinite.observer.observe(sentinel);
      } else if (state.infinite.observer) {
        state.infinite.observer.disconnect();
      }
    }

    function animateGridIn() {
      if (!grid) return;
      grid.classList.remove('is-swapping');
      grid.classList.add('is-entering');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          grid.classList.remove('is-entering');
        });
      });
    }

    function loadCollectionUrl(url, activeTabEl) {
      if (!grid || !sectionId || loading) return;
      if (state.searchActive && state.searchInput && state.searchInput.value.trim().length >= 2) {
        state.searchInput.value = '';
        state.searchActive = false;
        if (state.infiniteShow) state.infiniteShow();
      }

      setLoading(true);
      grid.classList.add('is-swapping');

      var fetchUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'sections=' + encodeURIComponent(sectionId);

      fetch(fetchUrl, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('section fetch failed');
          return r.json();
        })
        .then(function (data) {
          var parsed = parseSectionGrid(data, sectionId);
          if (!parsed.gridHtml) throw new Error('empty grid');
          grid.innerHTML = parsed.gridHtml;
          setOriginalHtml(grid.innerHTML);
          syncInfiniteFromParsed(parsed);
          if (typeof history !== 'undefined' && history.pushState) {
            history.pushState({ mmColSort: url }, '', url);
          }
          animateGridIn();
          if (activeTabEl && tabsWrap && indicator) {
            tabsWrap.querySelectorAll('.mm-collection-tab').forEach(function (t) {
              t.classList.remove('is-on');
            });
            activeTabEl.classList.add('is-on');
            positionTabIndicator(tabsWrap, activeTabEl, indicator);
          }
          window.scrollTo({ top: grid.offsetTop - 80, behavior: 'smooth' });
        })
        .catch(function () {
          window.location.href = url;
        })
        .finally(function () {
          setLoading(false);
        });
    }

    if (tabsWrap && indicator) {
      var initial = tabsWrap.querySelector('.mm-collection-tab.is-on');
      if (initial) {
        requestAnimationFrame(function () {
          positionTabIndicator(tabsWrap, initial, indicator);
        });
      }
      window.addEventListener('resize', function () {
        var on = tabsWrap.querySelector('.mm-collection-tab.is-on');
        if (on) positionTabIndicator(tabsWrap, on, indicator);
      });
      tabsWrap.addEventListener('scroll', function () {
        var on = tabsWrap.querySelector('.mm-collection-tab.is-on');
        if (on) positionTabIndicator(tabsWrap, on, indicator);
      });
    }

    var tabs = root.querySelectorAll('.mm-collection-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-on') || loading) return;
        var url = tab.getAttribute('data-url');
        if (!url) return;
        positionTabIndicator(tabsWrap, tab, indicator);
        loadCollectionUrl(url, tab);
      });
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        var url = sortSelect.value;
        if (!url || loading) return;
        tabs.forEach(function (tab) {
          tab.classList.toggle('is-on', tab.getAttribute('data-url') === url);
        });
        var match = tabsWrap ? tabsWrap.querySelector('.mm-collection-tab.is-on') : null;
        if (match && indicator) positionTabIndicator(tabsWrap, match, indicator);
        loadCollectionUrl(url, match);
      });
    }

    state.loadCollectionUrl = loadCollectionUrl;
  }

  function init(root) {
    var grid = document.getElementById('mmColGrid');
    var searchInput = document.getElementById('mmColSearch');
    var countEl = document.getElementById('mmColVisibleCount');
    var noResults = document.getElementById('mmColNoResults');
    var state = { catalog: readCatalog(), searchActive: false, searchInput: searchInput };
    var handle = root.getAttribute('data-collection-handle') || '';
    var catalogLimit = parseInt(root.getAttribute('data-catalog-limit'), 10) || 250;
    var originalGridHtml = grid ? grid.innerHTML : '';
    function getOriginalHtml() {
      return originalGridHtml;
    }
    function setOriginalHtml(html) {
      originalGridHtml = html;
    }
    var labels = {
      addToCart: root.getAttribute('data-label-add') || 'Add to cart',
      soldOut: root.getAttribute('data-label-sold-out') || 'Sold out',
      chooseFlavour: root.getAttribute('data-label-flavour') || 'Choose flavour',
      chooseFlavourError: root.getAttribute('data-label-flavour-error') || 'Select a flavour',
      wait: root.getAttribute('data-label-wait') || '...',
      added: root.getAttribute('data-label-added') || '✓',
      error: root.getAttribute('data-label-error') || 'Error',
      showing: root.getAttribute('data-label-showing') || 'Showing',
      of: root.getAttribute('data-label-of') || 'of'
    };

    function updateCount(visible, total, searching) {
      if (!countEl) return;
      if (searching) {
        countEl.textContent =
          labels.showing + ' ' + visible + ' ' + labels.of + ' ' + total;
      } else {
        countEl.textContent = total + ' ' + (root.getAttribute('data-label-products') || 'products');
      }
    }

    function filterSearch(query) {
      if (!grid) return;
      var q = (query || '').trim();
      if (q.length < 2) {
        state.searchActive = false;
        grid.innerHTML = originalGridHtml;
        if (noResults) noResults.hidden = true;
        if (state.infiniteShow) state.infiniteShow();
        updateCount(
          grid.querySelectorAll('.mm-product-card').length,
          state.catalog.length,
          false
        );
        return;
      }

      state.searchActive = true;
      if (state.infiniteHide) state.infiniteHide();

      var matched = state.catalog.filter(function (p) {
        return matchesQuery(q, p.searchIndex || p.title);
      });
      if (matched.length === 0) {
        grid.innerHTML = '';
        if (noResults) noResults.hidden = false;
      } else {
        if (noResults) noResults.hidden = true;
        grid.innerHTML = matched.map(function (p) {
          return buildCard(p, labels);
        }).join('');
      }
      updateCount(matched.length, state.catalog.length, true);
    }

    if (searchInput) {
      searchInput.addEventListener('input', function () {
        filterSearch(searchInput.value);
      });
    }

    if (grid) {
      grid.addEventListener('click', function (e) {
        var btn = e.target.closest('.mm-col-add-btn');
        if (!btn || btn.disabled) return;
        e.preventDefault();
        var card = btn.closest('.mm-product-card');
        addToCart(btn.getAttribute('data-variant-id'), btn, card);
      });
    }

    state.searchInput = searchInput;
    initQuickNav(root, grid, state, setOriginalHtml);

    var descToggle = document.getElementById('mmColDescToggle');
    var descEl = document.getElementById('mmColDesc');
    if (descToggle && descEl) {
      descToggle.addEventListener('click', function () {
        var expanded = descEl.classList.toggle('is-expanded');
        descToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        descToggle.textContent = expanded
          ? descToggle.getAttribute('data-less')
          : descToggle.getAttribute('data-more');
      });
    }

    function startWithCatalog(list) {
      state.catalog = list;
      updateCount(
        grid ? grid.querySelectorAll('.mm-product-card').length : 0,
        state.catalog.length,
        false
      );
    }

    if (searchInput && handle) {
      fetchFullCatalog(handle, catalogLimit, root, startWithCatalog);
    } else {
      startWithCatalog(state.catalog);
    }

    initInfiniteScroll(root, grid, state, getOriginalHtml, setOriginalHtml);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-mm-collection-page]');
    if (root) init(root);
  });

  global.MMCollectionPage = { init: init, addToCart: addToCart };
})(typeof window !== 'undefined' ? window : globalThis);
